import {Component} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {
  MEMBER_EVENTS_DETAIL,
  API_MEMBER_EVENTS_POST,
  API_MEMBER_EVENTS_PUT,
  API_URL_MY_SUBCOMMITTEE, API_URL_ORGANIZER_SUBCOMMITTEE,
} from 'manager/http-constants';
import {forkJoin, Observable} from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import {CONSTANT, LOADING_KEY} from 'src/app/shared/constant/constant';
import {MESSAGE_CODE} from 'src/app/shared/constant/message-constant';
import {TOAST} from 'src/app/shared/constant/primeng-constants';
import {GENERATE_INPUT_TYPE} from 'src/app/shared/generate/generate-input/constant';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import {CommonService} from 'src/app/shared/service/common.service';
import {DbOperationService} from 'src/app/shared/service/db-operation.service';
import {Validator} from 'src/app/shared/validator/validator';
import {PlatformComponent} from '../platform.component';

@Component({
  selector: 'app-e104',
  templateUrl: './e104.component.html',
  styleUrls: ['./e104.component.scss', '../platform.component.scss'],
})

/**
 * 会員主催イベント申請登録(E104)
 * 会員主催イベント申請登録確認(E105)
 */
export class E104Component extends PlatformComponent {
  // 画面.入力フォーム
  e104InputForm: FormGroup = this.formBuilder.group({
    // タイトル
    event_kbn: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'event_kbn',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // タイトル
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 内容
    contents: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'contents',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 日時
    date_and_time: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'date_and_time',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 会場
    place: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'place',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 参加費
    entry_fee: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'entry_fee',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 定員
    capacity: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'capacity',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 主催団体
    organizer: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'organizer',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // プログラム
    program: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'program',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 申し込みURL
    application_page_url: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'application_page_url',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // イベントURL/お知らせURL
    event_page_url: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'event_page_url',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    //  連絡先
    contact: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'contact',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    //  その他
    others: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'others',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 分科会
    subcommittee_id: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'member_event',
          'subcommittee_id',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
  });

  // 会員主催イベントIDを格納
  memberEventId: string = this.route.snapshot.queryParams.member_event_id;

  // 確認画面表示フラグ(true=会員主催イベント申請登録確認(E105),false=会員主催イベント申請登録(E104))
  confirmationFlag = false;

  // 掲載内容表示判定用
  event_kbn = 0;

  // 主催/参加分科会一覧を格納
  organizerSubcommitteeList: object[] = [];

  createUserId = 0;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを会員主催イベント申請登録(E204)に変更する
    this.router.navigate(['pages/platform/e104/' + this.inputType], {
      queryParams: {
        screenId: 'e104',
        member_event_id: this.memberEventId,
      },
    });
  }

  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(2016);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規初期表示
      this.seNewInitialData();
      // 主催/参加分科会一覧を取得
      this.getOrganizerSubcommittee();

    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 編集初期表示
      this.setEditInitialData();
    }

  }

  /**
   * 新規初期表示
   */
  private seNewInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.NEW == this.inputType)) {
      // 新規以外の場合
      return;
    }

    // 初期値セット
    this.commonService.setFormGroupInitialData(this.e104InputForm, {
      member_id: this.loginUser.member_id,
    });
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.EDIT == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MEMBER_EVENTS_DETAIL);

    // 会員主催イベント申請詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(MEMBER_EVENTS_DETAIL, this.memberEventId, true)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          return;
        }

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.e104InputForm,
          response.body
        );

        const eventKbnValue = this.e104InputForm.get('event_kbn')?.value;
        if (eventKbnValue) {
          this.viewChange({value: eventKbnValue});
        }

        this.createUserId = response.body.create_user_id;
        this.getOrganizerSubcommittee();

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MEMBER_EVENTS_DETAIL);
      });
  }

  /**
   * 会員主催イベント申請登録(E104)を表示する
   */
  public moveE104(): void {
    // 会員主催イベント申請登録(E104)へ遷移
    this.router.navigate(
      ['pages/platform/e104/' + this.route.snapshot.params.inputType],
      {
        queryParams: {
          screenId: 'e104',
          member_event_id: this.memberEventId,
        },
      }
    );

    // 会員主催イベント申請登録(E104)を表示する
    this.confirmationFlag = false;
  }

  /**
   * 会員主催イベント申請登録確認(E105)を表示する
   */
  public moveE105(): void {
    // 会員主催イベント申請登録確認(E105)を表示する
    this.confirmationFlag = true;

    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const e104InputForm: any = JSON.parse(
      JSON.stringify(this.e104InputForm.value)
    );

    // 関連するゴールをカンマ区切り変換
    // e104InputForm.sdgs_goal = e104InputForm.sdgs_goal.toString();

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    const task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        'member_event',
        e104InputForm
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // レスポンスを結合
      // const data = this.generateService.JoinValidationResponseList(dataList);

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 会員主催イベント申請登録確認(E105)へ遷移
      this.router.navigate(
        ['pages/platform/e104/' + this.route.snapshot.params.inputType],
        {
          queryParams: {
            screenId: 'e105',
            member_event_id: this.memberEventId,
          },
        }
      );

      // 会員主催イベント申請登録確認(E105)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 会員主催イベント申請登録完了(E106)へ遷移する
   */
  public moveE106(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const e104InputForm: any = JSON.parse(
      JSON.stringify(this.e104InputForm.value)
    );

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {

      // 新規登録の場合 (POST)
      e104InputForm.status = 1;
      e104InputForm.member_id = this.getLoginMemberId();
      this.dbOperationService
        .insertData(API_MEMBER_EVENTS_POST, e104InputForm)
        .subscribe((response) => {
          this.handleSaveResponse(response);
        });

    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {

      // 編集の場合 (PUT)
      e104InputForm.member_id = this.getLoginMemberId();
      e104InputForm.member_event_id = this.memberEventId;
      // 編集時にステータスを未承認に変更
      e104InputForm.status = 1;

      this.dbOperationService
        .updateData(API_MEMBER_EVENTS_PUT, this.memberEventId, e104InputForm)
        .subscribe((response) => {
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          if (API_RESPONSE.SUCCESS == response.body.Message) {
            this.router.navigate(['pages/platform/e106', this.inputType], {
              queryParams: {
                member_event_id: this.memberEventId,
              },
            });
          } else {
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E90003),
              })
            );

            this.confirmationFlag = false;
          }
        });
    }
  }

  /**
   * 保存レスポンスの処理
   */
  private handleSaveResponse(response: any) {
    // 画面ロードフラグをOFF(ロード終了)
    this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

    if (response.body.Message === API_RESPONSE.SUCCESS) {
      // 登録/更新が正常に完了した場合
      this.router.navigate(['pages/platform/e106', this.inputType], {
        queryParams: {
          member_event_id: this.memberEventId || '',
        },
      });
    } else {
      // 異常終了の場合
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.ERROR,
          summary: this.commonService.msg(MESSAGE_CODE.E00001),
          detail: this.commonService.msg(MESSAGE_CODE.E80002),
        })
      );
    }
  }

  public viewChange(event: any) {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    const e104InputForm: any = JSON.parse(
      JSON.stringify(this.e104InputForm.value)
    );
    this.event_kbn = event.value || event;
    console.log('View Change Triggered - Event KBN:', this.event_kbn);

    // 変動フォームコントロールを設定
    // 会員主催イベント
    if (1 == e104InputForm.event_kbn) {
      // 以下項目を非活性
      this.e104InputForm.get('subcommittee_id').disable();
      this.e104InputForm.get('date_and_time').enable();
      this.e104InputForm.get('place').enable();
      // 以下項目の値を削除
      this.e104InputForm.get('subcommittee_id').setValue(null);

      this.event_kbn = e104InputForm.event_kbn;
      // 分科会からのお知らせ
    } else if (2 == e104InputForm.event_kbn) {
      // 以下項目を非活性
      this.e104InputForm.get('subcommittee_id').enable();
      this.e104InputForm.get('date_and_time').disable();
      this.e104InputForm.get('place').disable();
      // 以下項目の値を削除
      this.e104InputForm.get('date_and_time').setValue(null);
      this.e104InputForm.get('place').setValue(null);
      this.e104InputForm.get('entry_fee').setValue(null);
      this.e104InputForm.get('capacity').setValue(null);
      this.e104InputForm.get('organizer').setValue(null);
      this.e104InputForm.get('program').setValue(null);
      this.e104InputForm.get('application_page_url').setValue(null);

      this.event_kbn = e104InputForm.event_kbn;

      // 会員からのお知らせ
    } else if (3 == e104InputForm.event_kbn) {
      this.e104InputForm.get('subcommittee_id').disable();
      this.e104InputForm.get('date_and_time').disable();
      this.e104InputForm.get('place').disable();
      // 以下項目の値を削除
      this.e104InputForm.get('subcommittee_id').setValue(null);
      this.e104InputForm.get('date_and_time').setValue(null);
      this.e104InputForm.get('place').setValue(null);
      this.e104InputForm.get('entry_fee').setValue(null);
      this.e104InputForm.get('capacity').setValue(null);
      this.e104InputForm.get('organizer').setValue(null);
      this.e104InputForm.get('program').setValue(null);
      this.e104InputForm.get('application_page_url').setValue(null);

      this.event_kbn = e104InputForm.event_kbn;

      // 分科会主催イベント
    } else if (4 == e104InputForm.event_kbn) {
      this.e104InputForm.get('subcommittee_id').enable();
      this.e104InputForm.get('date_and_time').enable();
      this.e104InputForm.get('place').enable();

      this.event_kbn = e104InputForm.event_kbn;

    } else {
      this.event_kbn = 0;
    }

  }

  /**
   * 主催/参加分科会一覧を取得
   */
  private getOrganizerSubcommittee(): void {

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_ORGANIZER_SUBCOMMITTEE);

    const userId =
      (this.inputType === GENERATE_INPUT_TYPE.EDIT && this.decisionSecretariat())
        ? this.createUserId
        : this.loginUser.user_id;


    // 会員主催イベント申請詳細を取得
    this.dbOperationService
      .getNoTemplateData(API_URL_ORGANIZER_SUBCOMMITTEE, {user_id: userId, user_kbn: '1'}, false)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          this.organizerSubcommitteeList = [];
          // this.setEditInitialData();
        } else {
          this.organizerSubcommitteeList = response.body;
          // this.setEditInitialData();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_ORGANIZER_SUBCOMMITTEE);
      });
  }
}
